import { FieldPickerPopUpContent } from "./fieldpicker-popup-content";
import { KPIPreview } from "./kpi-preview";

export const KPI = {
  KPIPreview,
  FieldPickerPopUpContent
};
